module.exports = __webpack_public_path__ + "static/img/name3.0f5b159.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/en/name3.png
// module id = xp3k
// module chunks = 1